(function($, Drupal) {
  'use strict';


  Drupal.behaviors.theshire = {
    already_run: false,
    masonryGrid: null,

    attach: function(context, settings) {

      // Pretty Drupal messages | must be above the already_run condition to work
      drupalMessages.init(context);

      // Only ever run this once on page load (otherwise there's a quirk that reruns it)
      if (this.already_run === true) {
        return;
      }
      this.already_run = true;

      // Navigation scripts
      home.init();

      // Navigation scripts
      navigationHandler.init();

      // Trigger script for flexible content
      flexibleContent.init(context);

      // Smooth scroll for URL hash fragments
      hashScrolls.init();

      // Smooth scroll for URL hash fragments
      videoPosterEmbed.init();

      // Archive masonry
      const $selector = $('.view-display-id-archive_page > .view-content, .view-display-id-news_page > .view-content, .view-display-id-news_category > .view-content');

      if ($selector.length !== 0) {
        $selector.prepend('<div class="grid-sizer"></div>');

        this.masonryGrid = $selector.masonry({
          itemSelector: '.views-row',
          columnWidth: '.grid-sizer',
          percentPosition: true
        });

        // imagesLoaded is included in the infinite scroll JS, so we can use it for masonry too
        this.masonryGrid.imagesLoaded().progress( function() {
          Drupal.behaviors.theshire.masonryGrid.masonry('layout');
        });
      }


      // Setup infinite scroll behaviour
      Drupal.behaviors.theshireInfinity.activate();


    }
  };

  const videoPosterEmbed = {
    init: function() {
      const videos = document.querySelectorAll('.paragraph--type--video.has-poster-image');
      for (var index = 0; index < videos.length; index++) {
        const video = videos[index];
        console.log(video);

      }
    },
  }

  var home = {
    init: function() {
      this.carousel();
    },
    carousel: function() {

      if ($('.field--name-field-carousel-slide .field__items').length) {
        var $slider = $('.field--name-field-carousel-slide .field__items');
        var $progressBar = $('.slick-progress');

        $slider.on('init', function(event, slick) {
          var calc = ( (slick.currentSlide+1) / (slick.slideCount) ) * 100;
          $progressBar
            .css('background-size', '100%' + calc + '%')
            .attr('aria-valuenow', calc );
        });

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          var calc = ( (nextSlide+1) / (slick.slideCount) ) * 100;
          $progressBar
            .css('background-size', '100%' + calc + '%')
            .attr('aria-valuenow', calc );
        });

        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 400,
          arrows: true,
          autoplay: false,
          autoplaySpeed: 6000
        });
      }

    },
  }

  var hashScrolls = {
    offset: 120,
    init: function() {
      this.onClick();
      this.onLoad();
    },
    onClick: function() {
      var anchors = document.querySelectorAll('a');
      for (var z = 0; z < anchors.length; z++) {
        anchors[z].addEventListener('click', function() {
          if (this.classList.contains('tablist__link')) {
            var elem = document.getElementById(this.hash.substr(1));
            var elemPos = getOffset(elem).top - hashScrolls.offset;
            scrollToY(elemPos, 1500, 'easeInOutQuint');
          }
        }, false);
      }
    },
    onLoad: function() {
      var hash = window.location.hash;
      if (hash) {
        // First find the yPos of the hash elem so we can pass this into our scroll function
        window.onload = function() {
          var elem = document.getElementById(hash.substr(1));
          var elemPos = getOffset(elem).top - hashScrolls.offset;
          scrollToY(elemPos, 1500, 'easeInOutQuint');
        }
      }
    }
  }

  var navigationHandler = {
    overlayTrigger: '.js--hamburger',
    init: function(context) {
      this.mobileMenu(context);
      this.mobileFloatingHamburger(context);
    },
    mobileMenu: function(context) {
      var scrollTo;
      var prevScrolPos;

      const that = this;

      // listen to mobileMenuToggle event
      $(document).on('mobileMenuToggle', function() {
        let ariaControls = null;

        $(that.overlayTrigger, context).each(function() {
          ariaControls = $(this).attr('aria-controls');
         console.log(ariaControls);

          $(this).attr('aria-expanded', function(i, attr) {
            return attr == 'true' ? 'false' : 'true';
          });
        });


        // toggle aria-hidden attribute on the target element
        $('#' + ariaControls).attr('aria-hidden', function(i, attr) {
          return attr == 'true' ? 'false' : 'true';
        });

        if (!$('body').hasClass('overlay-active')) {
          prevScrolPos = $(window).scrollTop();
          scrollTo = 0;
        } else {
          scrollTo = prevScrolPos;
        }

        $('body').toggleClass('overlay-active') && $('html,body').scrollTop(scrollTo);
      });

      // Emit the mobileMenuToggle event
      $(this.overlayTrigger, context).each(function() {
        $(this).on('click', function() {
          $(document).trigger('mobileMenuToggle');
        });
      });
    },
    mobileFloatingHamburger: function(context) {
      const siteHeader = document.getElementById('site-header');
      window.onscroll = function(e) {
        if (window.scrollY > siteHeader.offsetHeight)
          document.body.classList.add('floating-hamburger-active');
        else
          document.body.classList.remove('floating-hamburger-active');
      };
    },
  };

  var flexibleContent = {
    init: function() {
      this.lightbox();
      this.carousel();
      this.newsletter();
    },
    lightbox: function() {
      $(document).swipebox({
        selector: 'a.lightbox',
        hideBarsDelay: -1,

      afterOpen: function(){
        var $selectorClose = $("#swipebox-close");
        var clickAction = "touchend click";

        $selectorClose.unbind(clickAction);

        $selectorClose.bind(clickAction, function(event){
          event.preventDefault();
          event.stopPropagation();

          $.swipebox.close();
        });
        }
      });
      $(document).swipebox({
        selector: 'a.video-link',
        hideBarsDelay: -1
      });
    },
    carousel: function() {
      // Any sliders?
      var sliderMain = $(".carousel-dots .image-carousel").lightSlider({
        loop: true
      });

      $('.js-tablist__link').on('click', function() {
        // Any sliders?
        sliderMain.destroy();

        sliderMain = $(".carousel-dots .image-carousel").lightSlider({
          loop: true
        });
      });

    },
    newsletter: function() {
      var $originalFormAction = $('#mc-embedded-subscribe-form').attr('action');
      $("#mce-EMAIL").keyup(function () {
        var $value = $(this).val();
        $('#mc-embedded-subscribe-form').attr('action', $originalFormAction + '&MERGE0=' + $value);
      }).keyup();
    }
  }

  var drupalMessages = {
    init: function(context) {
      // Replace the yuk status messages
      var messages = [];

      $('.status, .status-messages .error', context).each(function() {
        var $title = $(this).parent().find('h2');
        var $message = $(this);
        console.log($message);


        // Don't this for really long messages. They're probably dev. errors
        // that we want to read.
        if ($message.text().length > 300) {
          return;
        }

        $(this).hide();

        // What kind of alert is it?
        var type = 'info';
        if ($message.hasClass('status')) {
          type = 'success';
        } else if ($message.hasClass('warning')) {
          type = 'warning';
        } else if ($message.hasClass('error')) {
          type = 'error';
        }

        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
        var comments = /<!--[\s\S]*?-->/gi

        // Add to the queue
        messages.push({
          'title': $title.html().replace(comments, '').replace(tags, ''),
          'text': $message.html().replace(comments, '').replace(tags, ''),
          'type': type
        });
      });
      if (messages.length) {
        swal.queue(messages)
      }
    }
  }

  // // first add raf shim
  // // http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
  // window.requestAnimFrame = (function() {
  //   return window.requestAnimationFrame ||
  //     window.webkitRequestAnimationFrame ||
  //     window.mozRequestAnimationFrame ||
  //     function(callback) {
  //       window.setTimeout(callback, 1000 / 60);
  //     };
  // })();

  // // main function
  // function scrollToY(scrollTargetY, speed, easing) {
  //   // scrollTargetY: the target scrollY property of the window
  //   // speed: time in pixels per second
  //   // easing: easing equation to use

  //   var scrollY = window.scrollY,
  //     scrollTargetY = scrollTargetY || 0,
  //     speed = speed || 2000,
  //     easing = easing || 'easeOutSine',
  //     currentTime = 0;

  //   // min time .1, max time .8 seconds
  //   var time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));

  //   // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
  //   var PI_D2 = Math.PI / 2,
  //     easingEquations = {
  //       easeOutSine: function(pos) {
  //         return Math.sin(pos * (Math.PI / 2));
  //       },
  //       easeInOutSine: function(pos) {
  //         return (-0.5 * (Math.cos(Math.PI * pos) - 1));
  //       },
  //       easeInOutQuint: function(pos) {
  //         if ((pos /= 0.5) < 1) {
  //           return 0.5 * Math.pow(pos, 5);
  //         }
  //         return 0.5 * (Math.pow((pos - 2), 5) + 2);
  //       }
  //     };

  //   // add animation loop
  //   function tick() {
  //     currentTime += 1 / 60;

  //     var p = currentTime / time;
  //     var t = easingEquations[easing](p);

  //     if (p < 1) {
  //       requestAnimFrame(tick);

  //       window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
  //     } else {
  //       window.scrollTo(0, scrollTargetY);
  //     }
  //   }

  //   // call it once to get started
  //   tick();
  // }

  // function getOffset(el) {
  //   el = el.getBoundingClientRect();
  //   return {
  //     left: el.left + window.scrollX,
  //     top: el.top + window.scrollY
  //   }
  // }

})(jQuery, Drupal);
